module.exports = __webpack_public_path__ + "assets/chevron-left-black.50a64000.svg";